import React from 'react';
import useWindowSize from '../Shared/hooks/useWindowSize';
import HeaderBannerLandingPC from './shared/pc';
import HeaderBannerLandingMobile from './shared/mobile';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const HeaderBannerLandingComponent = (props) => {
  const [width] = useWindowSize();
  if (!props?.fields || !props.params)
    return <GenericPlaceholder componentName="HeaderBannerLandingComponent" />;

  const isEliteTheme = props?.fields?.IsEliteTheme?.value;

  if (width && width <= 768) {
    return <HeaderBannerLandingMobile {...props} isEliteTheme={isEliteTheme} />;
  }
  return <HeaderBannerLandingPC {...props} isEliteTheme={isEliteTheme} />;
};

export default HeaderBannerLandingComponent;
